import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from '@angular/router';
import { T4coreModule, SystemRights, AuthGuard } from 't4core';
import { T4CommonModule } from '../../t4common/t4common';
import { LocationUsersComponent } from './Components/LocationUsers/LocationUsers';
import { EditLocationUserDialog } from './dialogs/EditLocationUser/EditLocationUser';
import { EditOpenHoursDialog } from './dialogs/editOpenHoursDialog/editOpenHoursDialog';
import { LocationComponent } from './views/general/Location.component';
import { PriceListComponent } from './views/pricelist/pricelist.component';
import { ManagePricelistsComponent } from './views/ManagePricelists/ManagePricelists.component';
import { CreatePricelistDialog } from './dialogs/CreatePricelistDialog/CreatePricelistDialog';
import { AddonsComponent } from './views/addons/addons.component';
import { CreateAddonDialog } from './dialogs/CreateAddonDialog/CreateAddonDialog';
import { EditCategoryDialog } from './dialogs/EditCategoryDialog/EditCategoryDialog';
import { ManageCategoriesComponent } from './Components/ManageCategories/ManageCategories.component';
import { CreateObjectTypeDialog } from './dialogs/CreateObjectTypeDialog/CreateObjectTypeDialog';
import { SettingsComponent } from './views/settings/settings.component';
import { EditUserComponent } from './Components/EditUserComponent/EditUserComponent';
import { RightsManagementComponent } from './Components/RightsManagementComponent/RightsManagementComponent';
import { EditUserDialog } from './dialogs/EditUserDialog/EditUserDialog';
import { FindUserDialog } from './dialogs/FindUserDialog/FindUserDialog';
import { UIService, LocationInfo } from 't4core';
import { UserManagement } from './views/UserManagement/UserManagement';
import { ObjectTypesComponent } from './views/ObjectTypes/ObjectTypes';
import { TypeCategoriesComponent } from './views/TypeCategories/TypeCategories';
import { TrailerPointComponent } from './Components/TrailerPointComponent/TrailerPointComponent';
import { IframeGeneratorComponent } from './views/IframeGenerator/IframeGenerator';
import { ManageIntegrationsComponent } from './views/ManageIntegrations/ManageIntegrations.component';
import { SparepartsComponent } from './views/SpareParts/Spareparts.component';
import { CreateSparepartsDialog } from './dialogs/CreateSpareparttDialog/CreateSparepartsDialog';
import { EmailTemplate } from './views/EmailTemplate/EmailTemplate';
import { NgxEditorModule } from 'ngx-editor';
import { SetupLocationsComponent } from './views/SetupLocations/SetupLocations.component';
import { ManageTranslationsComponent } from './views/manage-translations/manage-translations';
import { PendingChangesGuard } from '../../t4common/guards/pending-changes.guard';
import { ObjectTypeClass } from './views/ObjectTypeClass/ObjectTypeClass';
import { CreateObjectTypeClassDialog } from './dialogs/CreateObjectTypeClassDialog/CreateObjectTypeClassDialog';
import { ObjectTypeClassAttributeDialog } from './dialogs/ObjectTypeClassAttributeDialog/ObjectTypeClassAttributeDialog';
import { ObjectTypeClassDetails } from './views/ObjectTypeClassDetails/ObjectTypeClassDetails';
import { PhotoAngleDialog } from './dialogs/PhotoAngleDialog/PhotoAngleDialog';
import { SafetyCheckQuestionDialog } from './dialogs/SafetyCheckQuestionDialog/SafetyCheckQuestionDialog';

@NgModule({
    declarations: [
        LocationComponent,
        EditOpenHoursDialog,
        CreateSparepartsDialog,
        LocationUsersComponent,
        EditLocationUserDialog,
        PriceListComponent,
        ManagePricelistsComponent,
        CreatePricelistDialog,
        EditCategoryDialog,
        CreatePricelistDialog,
        AddonsComponent,
        CreateAddonDialog,
        ManageCategoriesComponent,
        CreateObjectTypeDialog,
        SettingsComponent,
        EditUserComponent,
        RightsManagementComponent,
        EditUserDialog,
        FindUserDialog,
        UserManagement,
        ObjectTypesComponent,
        TypeCategoriesComponent,
        TrailerPointComponent,
        IframeGeneratorComponent,
        ManageIntegrationsComponent,
        SparepartsComponent,
        EmailTemplate,
        SetupLocationsComponent,
        ManageTranslationsComponent,
        SetupLocationsComponent,
        ObjectTypeClass,
        CreateObjectTypeClassDialog,
        ObjectTypeClassAttributeDialog,
        ObjectTypeClassDetails,
        PhotoAngleDialog,
        SafetyCheckQuestionDialog
    ],
  imports: [
    NgxEditorModule,
        T4CommonModule,
        T4coreModule,
        RouterModule.forChild([
            {
                path: 'Settings',
                data: {
                    index: 20000, title: "Settings", toolTip: "Settings", roles: ['GroupManager', 'Admin', 'LocationManager', 'Clerk'], icon: 'settings'
                },
                children: [
                    { path: '', redirectTo: 'Location', pathMatch: 'full' },
                    //{
                    //    path: "General",
                    //    canActivate: [AuthGuard],
                    //    component: GeneralComponent,
                    //    data: { hidden: true, title: "General", toolTip: "General", icon: 'home' }
                    //},
                    {
                        path: "Location",
                        canActivate: [AuthGuard],
                        component: LocationComponent,
                        data: { title: "My store", toolTip: "My store", roles: ['LocationManager', 'Clerk'], icon: 'store_mall_directory' }
                    },
                    {
                        path: "Pricelist",
                        canActivate: [AuthGuard],
                        component: ManagePricelistsComponent,
                        data: { title: "Pricelists", toolTip: "Manage pricelists", roles: ['LocationManager', 'GroupManager'], icon: 'receipt' }
                    },
                    {
                        path: "RentalObjects",
                        canActivate: [AuthGuard],
                        data: { title: "Rental objects", toolTip: "Manage rental objects", roles: ['LocationManager', 'GroupManager'], icon: 'library_add' },
                        children: [
                          { path: '', redirectTo: 'Models', pathMatch: 'full' },
                            
                            {
                                  path: "Models",
                                  canActivate: [AuthGuard],
                                  component: ObjectTypesComponent,
                                  data: { title: "Models", roles: ['LocationManager', 'GroupManager'], icon: 'ballot' }
                            },
                            {
                              path: "ObjectTypeClass",
                              canActivate: [AuthGuard],
                              component: ObjectTypeClass,
                              data: { title: "Product Classes", roles: ['LocationManager', 'GroupManager'], icon: 'system_update_alt' }
                            },
                            {
                                path: "Categories",
                                canActivate: [AuthGuard],
                                component: TypeCategoriesComponent,
                                data: { title: "Product Families", roles: ['LocationManager', 'GroupManager'], icon: 'category' }
                            },
                            {
                                path: "Addons",
                                canActivate: [AuthGuard],
                                component: AddonsComponent,
                                data: { title: "Addons", roles: ['LocationManager', 'GroupManager'], icon: 'library_add' }
                            },
                            {
                              path: "Spareparts",
                              canActivate: [AuthGuard],
                              component: SparepartsComponent,
                              data: { title: "Spareparts", roles: ['LocationManager', 'GroupManager'], icon: 'settings_b_roll' }
                            },
                        ]
                  },
                  {
                    path: "ObjectTypeClassDetails/:Id",
                    canActivate: [AuthGuard],
                    component: ObjectTypeClassDetails,
                    data: { hidden: true, roles: ['Admin', 'LocationManager', 'GroupManager'] }
                  }, 
                    {
                      path: "SetupLocations",
                      canActivate: [AuthGuard],
                      component: SetupLocationsComponent,
                      data: { title: "Locations", toolTip: "Manage locations", roles: ['GroupManager'], icon: 'business' }
                    },
                    {
                      path: "EmailTemplate",
                      canActivate: [AuthGuard],
                      component: EmailTemplate,
                      data: { title: "Email Templates", toolTip: "Email Templates", roles: ['Admin', 'LocationManager', 'GroupManager'] }
                    },
                    {
                      path: "ManageTranslations",
                      canActivate: [AuthGuard],
                      canDeactivate: [PendingChangesGuard],
                      component: ManageTranslationsComponent,
                      data: {
                        title: "Manage Translations", toolTip: "ManageTranslations", roles: ['Admin', 'Backoffice', 'LocationManager', 'GroupManager'], icon: 'bar_chart' }
                    },
                    {
                      path: "UserManagement",
                      canActivate: [AuthGuard],
                      component: UserManagement,
                      data: { title: "User management", toolTip: "User management", roles: ['Admin'], icon: 'supervised_user_circle', color: 'accent2' }
                    },
                    {
                      path: "Settings2",
                      canActivate: [AuthGuard],
                      component: SettingsComponent,
                      data: { title: "Settings", toolTip: "Manage settings", roles: ['LocationManager', 'GroupManager'], rights: SystemRights.T4_Settings_ChangeSettings, icon: 'settings' }
                    },
                    {
                      path: "Pricelist/:Id",
                      canActivate: [AuthGuard],
                      component: PriceListComponent,
                      data: { hidden: true, roles: ['LocationManager', 'GroupManager'] }
                    },
                    {
                      path: "Pricelist/:Id/:ChildId",
                      canActivate: [AuthGuard],
                      component: PriceListComponent,
                      data: { hidden: true, roles: ['GroupManager'] }
                    },
                    {
                      path: "Intergration",
                      canActivate: [AuthGuard],
                      component: ManageIntegrationsComponent,
                      data: { title: "Integrations", toolTip: "Manage integrations", roles: ['LocationManager', 'GroupManager'], icon: 'settings_applications' }
                    },
                ]
            },
        ])
    ],
    providers: [T4CommonModule, { provide: APP_INITIALIZER, useFactory: initModule, deps: [UIService], multi: true }]
})
export class Settings { }

// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({
      dialogs: [
        { key: "T4.Settings.FindUser", dialog: FindUserDialog },
        { key: "T4.Settings.EditUser", dialog: EditUserDialog }
      ]
    });
  };
}
